import SpriteSymbol from "../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "confirm-icon",
  "use": "confirm-icon-usage",
  "viewBox": "0 0 82 58",
  "content": "<symbol viewBox=\"0 0 82 58\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"confirm-icon\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M79.5079 1.26375C81.8476 3.20092 82.1739 6.668 80.2368 9.0077L41.7368 55.5077C39.8787 57.7518 36.5931 58.1577 34.2449 56.4332L2.24486 32.9332C-0.203427 31.1352 -0.730621 27.6929 1.06734 25.2446C2.86531 22.7964 6.30758 22.2692 8.75587 24.0671L36.5733 44.4956L71.764 1.99259C73.7011 -0.347105 77.1682 -0.673418 79.5079 1.26375Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol